// Theme Specific Files
//@codekit-prepend "smoothscroll.js"
//@codekit-prepend "font-awesome.js"
//codekit-prepend "jquery.sticky-sidebar.min.js"

//codekit-prepend "../JR-Starter/general/jquery.js"
//codekit-prepend "../JR-Starter/general/scrollmagic.js"
//codekit-prepend "../JR-Starter/general/scrollmagic-indicators.js"
//codekit-prepend "../JR-Starter/general/dzsparallaxer.js"
//@codekit-prepend "../JR-Starter/general/slick.js"
//codekit-prepend "../JR-Starter/general/google-maps.js"
//@codekit-prepend "../JR-Starter/general/jquery.cookie.js"

//@codekit-prepend "../JR-Starter/jr-starter.js"


(function ($) {

	"use strict";

	var $window,
		$header,
		$body,
		$wpAdminBar,
		$mastHead,
		$metaWrapper,
		$hero;

	$(document).ready(jrDocumentReady);

	// Callback function for when the page is ready
	function jrDocumentReady() {

		$window = $(window);
		$body = $('body');
		$header = $('#jr-header');
		$wpAdminBar = $('#wpadminbar');
		$mastHead = $('#masthead');
		$metaWrapper = $('.meta-wrapper');
		$hero = $('.hero-image');

		var scrolledFlag = false;

		if ($window.scrollTop() > 0) {
			$mastHead.addClass('active');
		}

		var flag = true;

		$window.scroll(function () {
			if ($window.scrollTop() > 0) {
				if (scrolledFlag !== true) {
					$mastHead.addClass('active');
				}
				scrolledFlag = true;
			} else {
				if (scrolledFlag !== false) {
					$mastHead.removeClass('active');
				}
				scrolledFlag = false;
			}

			if ( $hero.length === 1 ) {
				parallax();
			}
			
			

		});

		// Hero parallax
		function parallax() {

			var scrolled = $(window).scrollTop();
			$hero.css('transform', 'translate3d(0,' + (scrolled * 0.2) + 'px, 0)');
			//$metaWrapper.css('transform', 'translate3d(-50%,' + (scrolled * 0.1) + 'px, 0)');
			//$pageHeader.css('opacity', 1 - (scrolled * .00175));
		};

		$('.jr-sidebar').hcSticky({
			stickTo: '#main-content > .row',
			top: $('#masthead').outerHeight(true) + 80,
		});

		// Mobile menu
		$('.jr-menu .menu-button').click(function() {
			if ( $body.hasClass('mobile-menu-active')) {
				$body.removeClass('mobile-menu-active');
			} else {
				$body.addClass('mobile-menu-active');
			}
		});

		$('#mobile-menu .dismiss, .mobile-menu-container').click(function(e) {
			e.stopPropagation();
			$body.removeClass('mobile-menu-active');
		});

		$('#mobile-menu .menu-item , #mobile-menu .company-logo-link').click(function(e) {
			e.stopPropagation();
		});


		// Form select
		$('#free-directory-forms .directory-form').eq(1).hide();
		$('#free-directory-forms button').on('click', function(e) {
			e.preventDefault();
			$('#free-directory-forms button').removeClass('inactive').data('inactive', false);
			$('#free-directory-forms button').not( $(this) ).addClass('inactive').data('inactive', true);
			var formID = $(this).data('form');
			$('#free-directory-forms .directory-form').hide();
			$('#form-id-' + formID).show();

		});

		$('#free-directory-forms button').hover(function() {
			if ( $(this).hasClass('inactive') ) {
				$(this).data('inactive', true).removeClass('inactive');
			}
		}, function() {
			if ( $(this).data('inactive') === true ) {
				$(this).data('inactive', true).addClass('inactive');
			}
		});

		// Register advert clicks
		$('.box-grid').on( 'click', '.post-type-advert', function() {

			// Dont track if not gtag theme enabled
			if ( ! $('body').hasClass('theme-gtag') ) {
				return;
			}

			var url = $(this).prop('href');

			gtag('event', 'click', {
				'event_category': 'outbound',
				'event_label': url
			});

		});

		$('.custom-item-13253').find('a').attr('target', '_blank');

		headerCarousel.init();

		// Icons in a list
		$('ul.icon-check').addClass('fa-ul').find('li').prepend('<span class="fa-li"><i class="fas fa-check"></i></span>');
		

	}


	$(window).load(function () {

		var $placeholders = $('.image-wrapper');

		$placeholders.each(function () {
			var $this = $(this);
			var largeImage = new Image();
			largeImage.src = $this.data('src');
			largeImage.srcset = $this.data('srcset');
			largeImage.sizes = $this.data('sizes');
			largeImage.alt = $this.data('alt');
			var objectFit = $this.data('object-fit');
			var objectPosition = $this.data('object-position');
			largeImage.classList.add('large-image');



			if (typeof objectFit !== 'undefined' && objectFit) {
				$(largeImage).css({
					'object-fit': objectFit
				});
			}
			if (typeof objectPosition !== 'undefined' && objectPosition) {
				$(largeImage).css({
					'object-position': objectPosition
				});
			}

			largeImage.onload = function () {
				$this.addClass('loaded');
				headerCarousel.start();
			}
			$this.append(largeImage);
		});


	});


	var headerCarousel = {

		count: 0,
		currentSlide: null,
		selector: '.header-image-container',
		$container: null,
		$slides: null,
		interval: 6000,
		status: null,

		init() {
			this.$container = $(this.selector);
			this.$slides = this.$container.find('.hero-image');
			this.count = this.$slides.length;
			this.status = 'init';
		},

		start() {

			if ( this.status === 'start' || this.count <= 1 ) {
				return;
			}

			this.status = 'start';

			this.advanceSlide();

			setInterval(() => {
				this.advanceSlide();
			}, this.interval);

		},

		advanceSlide() {
			var currentSlide = this.currentSlide;

			// Set current slide
			if ( currentSlide === null || currentSlide >= ( this.count - 1 ) ) {
				currentSlide = 0;
			} else {
				currentSlide = currentSlide + 1;
			}

			this.currentSlide = currentSlide;

			var $currentSlide = this.$slides.eq( currentSlide );

			$currentSlide.addClass('active animate-in zoom-in');

			setTimeout(() => {
				this.$slides.not($currentSlide).removeClass('active zoom-in');
				$currentSlide.removeClass('animate-in');
			}, 1000);

		}

	}



}(jQuery));


